import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import '../Admin/components/commonstyle.scss';

import Layout from '../Admin/components/Layout';
import ProtectedRouteLatest from '../Admin/components/Login/ProtectedRouteLatest';
import LoginPage from '../Admin/components/Login/LoginPage';
import AdminAccount from '../Admin/components/AccountSetup';
import OnBoardingAccount from '../Admin/components/OnBoarding';
import ResetPassword from '../Admin/components/ResetPassword';
import RegistrationSetUp from '../Admin/components/RegistrationSetup/RegistrationSetup';
import PasswordReset from '../Admin/components/PasswordReset/PasswordReset';
import ForgotPassword from '../Admin/components/PasswordRecovery';
import EmailReset from '../Admin/components/EmailReset/EmailReset';
import AdminDashboard from '../Admin/components/RegistrationSetup/AdminDashboard';
import Preference from '../Admin/components/Preference/preference';
import ServerError from '../Admin/errorhandling/ServerError';
import ClientError from '../Admin/errorhandling/ClientError';
import Logout from '../Admin/components/Logout/Logout';
import SessionLogout from '../Admin/components/Logout/SessionLogout';
import WhiteLabeling from '../Admin/components/WhiteLabeling/whitelabelingview';
import EditWhiteLabeling from '../Admin/components/WhiteLabeling/whitelabelingedit';
import WorkInProgress from '../Admin/components/BreadCrumb/workinprogress';
import ViewMember from '../Admin/components/ViewMember/ViewMember';
import ClaimDetails from '../Admin/components/ViewMember/claims/details/claimdetails';
import LoginOTP from '../Admin/components/Login/loginOTP';
import MemberManagement from '../Admin/components/MemberManagement/MemberManagement';
import ConfigureSocialMedia from '../Admin/components/ConfigureSocialMedia/ConfigureSocialMedia';
import SecuritySettings from '../Admin/components/SecuritySettings';
import OTPError from '../Admin/errorhandling/OTPerror';
import PriceCompare from '../Admin/components/PriceCompare/PriceCompare';
import SearchResults from '../Admin/components/PriceCompare/search-result/SearchResults';
import PriceCompareDoctorDetails from '../Admin/components/PriceCompare/find-doctor/doctor-details/ProviderDetails';
import PriceCompareFacilityDetails from '../Admin/components/PriceCompare/find-doctor/facility-details/FacilityDetails';
import ClaimDetailsDoctorDetails from '../Admin/components/searchClaims/details/FacilityProviderDetails/doctor-details/ProviderDetails';
import ClaimDetailsFacilityDetails from '../Admin/components/searchClaims/details/FacilityProviderDetails/facility-details/FacilityDetails';
import ResultPage from '../Admin/components/PriceCompare/result-page/ResultPage';
import HelpCenter from '../Admin/components/HelpCenter/HelpCenter';
import AllServiceRequest from '../Admin/components/PriceCompare/recent-search/all-service-request/AllServiceRequest';
import Configuration from '../Admin/components/Configuration/Configuration';
import ReportSetting from '../Admin/components/ReportSetting/commonPreference';
import PasswordSuccess from '../Admin/components/myProfile/Component/PasswordSuccess';
import SearchClaims from '../Admin/components/searchClaims/SearchClaims';
import SearchClaimsResults from '../Admin/components/searchClaims/searchResults/SearchClaimsResults';
import SearchClaimDetails from '../Admin/components/searchClaims/details/claimdetails';
import ManageHelpDocuments from '../Admin/components/ManageHelpDocuments';
//import Approval from '../Admin/components/Approval';
//import ApprovalRequest from '../Admin/components/Approval/ApprovalRequest';

//FUTURE: Delete the old folder's once changes in below newly created folder are stable
import { ManagePermissionGroup } from 'src/Admin/components/PermissionGroups';
//FUTURE: Delete the old folder's once changes in below newly created folder are stable
import {
  EditUser,
  EditNewUser,
  DuplicateUser,
  ManageUsers,
  CreateUserNew,
} from 'src/Admin/components/User';

import {
  EditContact,
  CreateContact,
  Contacts,
} from 'src/Admin/components/Contacts';
//TODO: Need to rename the folder ConfigurePages to Pages
import {
  EditPage,
  CreatePage,
  ConfigurePages,
} from 'src/Admin/components/ConfigurePages';
//TODO: Need to rename the folder ConfigureLinks to Links
import {
  EditLink,
  CreateLink,
  DuplicateLink,
  ConfigureLinks,
} from 'src/Admin/components/ConfigureLinks';
//TODO: Need to rename the folder ConfigureResources to Resources
import {
  EditResource,
  CreateResource,
  DuplicateResource,
  ConfigureResources,
} from 'src/Admin/components/ConfigureResources';
import PageNotFound from 'src/Components/PageNotFound';
import UploadDocument from 'src/Admin/components/uploaddocument/UploadDocument';
import ViewDocument from 'src/Admin/components/uploaddocument/ViewDocument';
import SecurityQuestionsPanel from 'src/Admin/components/OnBoarding/SecurityQuestions';
import Reports from 'src/Admin/components/Reports';
import GenerateReports from 'src/Admin/components/Reports/GenerateReports';
import MyProfile from 'src/Admin/components/myProfile/MyProfile';
import PublishNewMessage from 'src/Admin/components/Documents/publishMessage/PublishNewMessage';
import MessageAndDocument from 'src/Admin/components/Documents/MessageAndDocument';
import EnrollmentRules from 'src/Admin/components/Enrollment/EnrollmentRules';
import CreateNewRule from 'src/Admin/components/EnrollmentRules/CreateNewRule';
import EnrollmentLifeEvent from 'src/Admin/components/Enrollment/EnrollmentLifeEvent';
import EnrollmentCoverageFlow from 'src/Admin/components/Enrollment/components/enrollment-coverage-flow/EnrollmentCoverageFlow';
import EnrollmentSuccess from 'src/Admin/components/Enrollment/components/enrollment-success/EnrollmentSuccess';
import ProviderSelfRegistration from 'src/Admin/components/ProviderSelfRegistration/ProviderSelfRegistration';
import ProviderRegistrationSuccess from 'src/Admin/components/ProviderSelfRegistration/ProviderRegistrationSuccess';
import Approval from 'src/Admin/components/Approval';
import ApprovalRequest from 'src/Admin/components/Approval/ProviderSelfRegistation/ApprovalRequest';
import EditUserRequest from 'src/Admin/components/Approval/ProviderSelfRegistation/EditUserRequest';
import EditAffiliationRequest from 'src/Admin/components/Approval/ProviderSelfRegistation/EditAffiliationRequest';
import EnrollmentDetails from 'src/Admin/components/Approval/EnrollmentRequests/EnrollmentDetails';
import AffiliationCard from 'src/Admin/components/Approval/EnrollmentRequests/Affiliation/AffiliationCard';
import DashboardAffiliateAccount from 'src/Admin/components/affiliateaccount/DashboardAffiliateAccount';
import SelfAccountUnlock from 'src/Admin/components/SelfAccountUnlock';
import EnumerationAuditLog from 'src/Admin/components/PermissionGroups/EnumerationAuditLog/EnumerationAuditLog';

export default function () {
  const is404Error = useSelector(({ app }) => app.is404Error);

  return (
    !is404Error && (
      <Layout>
        <Routes>
          <Route exact path="/admin/" element={<LoginPage />} />
          <Route
            exact
            path="/admin/provider-self-registration"
            element={<ProviderSelfRegistration />}
          />
          <Route
            exact
            path="/admin/provider-self-registration/success"
            element={<ProviderRegistrationSuccess />}
          />

          <Route exact path="/admin/account-setup" element={<AdminAccount />} />
          <Route
            exact
            path="/admin/onboarding/:id"
            element={<OnBoardingAccount />}
          />
          <Route
            exact
            path="/admin/reset-password/:id"
            element={<ResetPassword />}
          />
          <Route exact path="/admin/login-otp" element={<LoginOTP />} />
          <Route exact path="/admin/server-error" element={<ServerError />} />
          <Route exact path="/admin/client-error" element={<ClientError />} />
          <Route exact path="/admin/logout" element={<Logout />} />
          <Route
            exact
            path="/admin/session-expired"
            element={<SessionLogout />}
          />
          <Route exact path="/admin/otp-error" element={<OTPError />} />
          <Route
            exact
            path="/admin/password-change-success"
            element={<PasswordSuccess />}
          />
          <Route
            exact
            path="/admin/password-recovery"
            element={<ForgotPassword />}
          />
          <Route
            exact
            path="/admin/security-questions"
            element={<SecurityQuestionsPanel />}
          />
          <Route element={<ProtectedRouteLatest />}>
            <Route path="/admin/admin-dashboard" element={<AdminDashboard />} />
            <Route
              path="/admin/affiliate-account"
              element={<DashboardAffiliateAccount />}
            />
            <Route path="/admin/password-reset" element={<PasswordReset />} />
            <Route path="/admin/email-reset" element={<EmailReset />} />
            <Route path="/admin/preferences" element={<Preference />} />
            <Route
              path="/admin/registration-setup"
              element={<RegistrationSetUp />}
            />
            {/*<Route path="/admin/create-new-user" element={ <CreateUser /> } /> */}
            <Route
              path="/admin/user-management"
              element={
                <React.Suspense fallback={null}>
                  <ManageUsers />
                </React.Suspense>
              }
              //element={<ManageUsers />}
            />
            <Route path="/admin/edit-user" element={<EditUser />} />
            <Route path="/admin/edit-new-user" element={<EditNewUser />} />
            <Route path="/admin/duplicate-user" element={<DuplicateUser />} />
            <Route path="/admin/white-labeling" element={<WhiteLabeling />} />
            <Route
              path="/admin/white-labeling-edit"
              element={<EditWhiteLabeling />}
            />
            <Route path="/admin/workinprogress" element={<WorkInProgress />} />
            <Route
              path="/admin/user-group"
              //element={<ManagePermissionGroup />}
              element={
                <React.Suspense fallback={null}>
                  <ManagePermissionGroup />
                </React.Suspense>
              }
            />
            <Route path="/admin/view-member" element={<ViewMember />} />
            {/*<Route path='/admin/coverage' element={ <CoverageDetails /> } />
        <Route path='/admin/claims' element={ <Claims /> } /> */}
            <Route path="/admin/claim-details" element={<ClaimDetails />} />
            {/*<Route path='/admin/accounts' element={ <Accounts /> } /> */}
            <Route
              path="/admin/member-management"
              element={<MemberManagement />}
            />
            <Route
              path="/admin/configure-links"
              element={
                <React.Suspense fallback={null}>
                  <ConfigureLinks />
                </React.Suspense>
              }
              //element={<ConfigureLinks />}
            />
            <Route path="/admin/create-link" element={<CreateLink />} />
            <Route path="/admin/edit-link" element={<EditLink />} />
            <Route
              path="/admin/configure-pages"
              element={
                <React.Suspense fallback={null}>
                  <ConfigurePages />
                </React.Suspense>
              }
              //element={<ConfigurePages />}
            />
            <Route path="/admin/edit-page" element={<EditPage />} />
            <Route path="/admin/create-page" element={<CreatePage />} />
            <Route
              path="/admin/contacts"
              element={
                <React.Suspense fallback={null}>
                  <Contacts />
                </React.Suspense>
              }
              //element={<Contacts />}
            />
            <Route
              path="/admin/configure-socialmedia"
              element={
                <React.Suspense fallback={null}>
                  <ConfigureSocialMedia />
                </React.Suspense>
              }
              //element={<ConfigureSocialMedia />}
            />
            <Route path="/admin/new-contact" element={<CreateContact />} />
            <Route path="/admin/edit-contact" element={<EditContact />} />
            <Route
              path="/admin/configure-resources"
              //element={<ConfigureResources />}
              element={
                <React.Suspense fallback={null}>
                  <ConfigureResources />
                </React.Suspense>
              }
            />
            <Route path="/admin/create-resource" element={<CreateResource />} />
            <Route path="/admin/edit-resource" element={<EditResource />} />
            <Route
              path="/admin/duplicate-resource"
              element={<DuplicateResource />}
            />
            <Route path="/admin/duplicate-link" element={<DuplicateLink />} />
            <Route
              path="/admin/security-settings"
              element={<SecuritySettings />}
            />
            <Route
              path="/admin/create-new-user-new"
              element={
                <React.Suspense fallback={null}>
                  <CreateUserNew />
                </React.Suspense>
              }
              //element={<CreateUserNew />}
            />
            <Route path="/admin/price-compare" element={<PriceCompare />} />
            <Route
              path="/admin/price-compare/search-results"
              element={<SearchResults />}
            />
            <Route
              path="/admin/price-compare/doctor-details/:id/:coord"
              element={<PriceCompareDoctorDetails />}
            />
            <Route
              path="/admin/claim-details/facility-details/:id"
              element={<ClaimDetailsFacilityDetails />}
            />
            <Route
              path="/admin/claim-details/doctor-details/:id"
              element={<ClaimDetailsDoctorDetails />}
            />
            <Route
              path="/admin/price-compare/facility-details/:id/:coord"
              element={<PriceCompareFacilityDetails />}
            />
            <Route
              path="/admin/price-compare/all-service-request"
              element={<AllServiceRequest />}
            />
            <Route
              path="/admin/price-compare/show-result"
              element={<ResultPage />}
            />
            <Route
              path="/admin/price-compare/show-result/:id"
              element={<ResultPage />}
            />
            <Route path="/admin/configuration" element={<Configuration />} />
            <Route path="/admin/upload-document" element={<UploadDocument />} />
            <Route path="/admin/view-documents" element={<ViewDocument />} />
            <Route path="/admin/report-setting" element={<ReportSetting />} />
            <Route path="/admin/reports" element={<Reports />} />
            <Route
              path="/admin/generate-report"
              element={<GenerateReports />}
            />
            <Route path="/admin/help-center" element={<HelpCenter />} />
            <Route path="/admin/my-profile" element={<MyProfile />} />
            <Route path="/admin/search-claims" element={<SearchClaims />} />
            <Route
              path="/admin/search-claims-results"
              element={<SearchClaimsResults />}
            />
            <Route
              path="/admin/search-claim-details"
              element={<SearchClaimDetails />}
            />
            <Route
              path="/admin/publish-new-message"
              element={<PublishNewMessage />}
            />
            <Route
              path="/admin/Messages-Documents"
              element={<MessageAndDocument />}
            />
            <Route path="/admin/approvals" element={<Approval />} />
            <Route
              path={`/admin/account-unlock`}
              element={<SelfAccountUnlock />}
            />
            <Route
              path="/admin/enumeration-audit"
              element={<EnumerationAuditLog />}
            />
            <Route
              path="/admin/approval-requests"
              element={<ApprovalRequest />}
            />
            <Route
              path="/admin/edituser-request"
              element={<EditUserRequest />}
            />
            <Route
              path="/admin/edit-affiliation-request"
              element={<EditAffiliationRequest />}
            />
            <Route
              path="/admin/enrollment-rules"
              element={<EnrollmentRules />}
            />
            <Route
              path="/admin/enrollment-life-event"
              element={<EnrollmentLifeEvent />}
            />
            <Route
              path="/admin/enrollment-coverage"
              element={<EnrollmentCoverageFlow />}
            />
            <Route
              path="/admin/enrollment-success"
              element={<EnrollmentSuccess />}
            />

            <Route
              path="/admin/approvals/request/details"
              element={<EnrollmentDetails />}
            />

            <Route
              path="/admin/enrollment-rules/create-new-rule"
              element={<CreateNewRule />}
            />
            <Route
              path="/admin/approvals/request/details/handle-affiliation-requests"
              element={<AffiliationCard />}
            />
            <Route
              path="/admin/manage-help-documents"
              element={<ManageHelpDocuments />}
            />
          </Route>

          <Route
            path="/admin/*"
            component={(property) => {
              const pathname = property.location.pathname;

              return <PageNotFound pathname={pathname} from="admin" />;
            }}
          />
        </Routes>
      </Layout>
    )
  );
}
